/*
 * cluutch-installments.js
 * Tient à jour la mention « paiement en plusieurs fois » quand la variante change.
 *
 * Le montant initial est rendu côté serveur ; ce script ne fait que le recalculer et
 * masquer la mention si la variante choisie sort des bornes d'éligibilité.
 *
 * Choix structurants :
 * - écoute sur `document` : le thème diffuse `product:variant-change` via dispatchCustomEvent
 *   (app.js), qui émet sur document sans bubbling ;
 * - garde sur `detail.variant` : custom.js re-diffuse le même événement SANS detail pour un
 *   produit particulier, ce qui provoquerait sinon une erreur à chaque changement ;
 * - formatage par formatMoney() avec le format du thème, qui est shop.money_format : le rendu
 *   est alors strictement identique à celui du filtre `money` du serveur ;
 * - arrondi au centime supérieur, comme le Liquid : on ne sous-annonce jamais une échéance.
 * Auteur : Cluutch / Studio Hogo.
 */
(function () {
	if (window.cluutchInstallmentsReady) return;
	window.cluutchInstallmentsReady = true;

	function majMention(el, prixCentimes) {
		var nb = parseInt(el.dataset.count, 10) || 4;
		var min = parseInt(el.dataset.min, 10) || 0;
		var max = parseInt(el.dataset.max, 10) || Number.MAX_SAFE_INTEGER;

		if (typeof prixCentimes !== 'number' || prixCentimes < min || prixCentimes > max) {
			el.hidden = true;
			return;
		}

		var montant = el.querySelector('[data-cluutch-inst-amount]');
		if (montant && typeof formatMoney === 'function') {
			var format = (window.theme && window.theme.settings && window.theme.settings.money_with_currency_format) || '{{amount}}';
			montant.innerHTML = formatMoney(Math.ceil(prixCentimes / nb), format);
		}
		el.hidden = false;
	}

	// Seules les mentions de la section qui a émis : l'aperçu rapide d'un autre produit (tiroir,
	// recommandations) émet le même événement avec son propre sectionId.
	function mentionsDe(sectionId) {
		return [].filter.call(document.querySelectorAll('[data-cluutch-installments]'), function (el) {
			var section = el.closest('.shopify-section');
			return !sectionId || !section || section.id === 'shopify-section-' + sectionId;
		});
	}

	document.addEventListener('product:variant-change', function (e) {
		// custom.js re-diffuse cet événement sans detail : on l'ignore.
		if (!e.detail || !e.detail.variant) return;
		var prix = e.detail.variant.price;
		// Fiche 2026 : le moteur d'achat écrit le total (rouge + articles cochés, ou le coffret)
		// en `data-cluutch-total` sur <product-form> ; les échéances se calculent sur ce total.
		var formulaire = e.detail.sectionId ? document.querySelector('product-form[data-section="' + e.detail.sectionId + '"]') : null;
		if (formulaire && formulaire.dataset.cluutchTotal) prix = parseInt(formulaire.dataset.cluutchTotal, 10) || prix;
		mentionsDe(e.detail.sectionId).forEach(function (el) {
			majMention(el, prix);
		});
	});

	// Le même total, au changement d'état du moteur (case cochée).
	document.addEventListener('cluutch:pdp-total', function (e) {
		if (!e.detail || typeof e.detail.total !== 'number') return;
		mentionsDe(e.detail.sectionId).forEach(function (el) {
			majMention(el, e.detail.total);
		});
	});
})();
